import { get, post, put } from "./Config";
import config from "util/config";

export function getNewApiBaseUrl() {
  const newApiUrl = config.config().NEW_API_URL;
  return newApiUrl && String(newApiUrl).trim() ? newApiUrl : undefined;
}

export function extractData(res) {
  return res?.data ?? res?.response?.data;
}

export function asDataResponse(res) {
  if (res?.data?.resultCode != null) {
    return res;
  }
  const data = extractData(res);
  if (data?.resultCode != null) {
    return { data };
  }
  return null;
}

function isUnimplementedNewApi(normalized) {
  const code = String(normalized?.data?.resultCode ?? "");
  const description = String(normalized?.data?.resultDescription ?? "");
  return code === "40400" && description === "Not found";
}

function shouldUseNewApiResponse(normalized) {
  return Boolean(normalized) && !isUnimplementedNewApi(normalized);
}

export async function getWithNewApiFallback(
  url,
  { params, timeOut } = {},
  label = "api"
) {
  const newBase = getNewApiBaseUrl();
  if (newBase) {
    const res = await get({ url, params, timeOut, baseURL: newBase });
    const normalized = asDataResponse(res);
    if (shouldUseNewApiResponse(normalized)) {
      return normalized;
    }
    console.log(
      `[${label}] new API missing resultCode, fallback to legacy >>`,
      extractData(res)
    );
  }
  return get({ url, params, timeOut });
}

export async function postWithNewApiFallback(
  url,
  { data, timeOut } = {},
  label = "api"
) {
  const newBase = getNewApiBaseUrl();
  if (newBase) {
    const res = await post({ url, data, timeOut, baseURL: newBase });
    const normalized = asDataResponse(res);
    if (shouldUseNewApiResponse(normalized)) {
      return normalized;
    }
    console.log(
      `[${label}] new API missing resultCode, fallback to legacy >>`,
      extractData(res)
    );
  }
  return post({ url, data, timeOut });
}

export async function putWithNewApiFallback(
  url,
  { data, timeOut } = {},
  label = "api"
) {
  const newBase = getNewApiBaseUrl();
  if (newBase) {
    const res = await put({ url, data, timeOut, baseURL: newBase });
    const normalized = asDataResponse(res);
    if (shouldUseNewApiResponse(normalized)) {
      return normalized;
    }
    console.log(
      `[${label}] new API missing resultCode, fallback to legacy >>`,
      extractData(res)
    );
  }
  return put({ url, data, timeOut });
}
